import React, { useEffect, createContext, useContext, useState, ReactNode } from 'react';
import useAuthStore from 'store/auth';

interface TraderContextType {
  traderId: string | null;
  setTraderId: (id: string) => void;
}

const TraderContext = createContext<TraderContextType | undefined>(undefined);

export const TraderProvider = ({ children }: { children: ReactNode }) => {
  const user = useAuthStore((state) => state.user);
  const [traderId, setTraderId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user !== undefined) {
      // Check if there's a saved trader in localStorage first
      const savedTrader = localStorage.getItem('selectedTrader');
      let initialTraderId: string | null = null;

      if (savedTrader && user?.traders?.length > 0) {
        // Find the saved trader in the user's traders list
        const savedTraderObj = user.traders.find(trader => trader.name === savedTrader);
        if (savedTraderObj) {
          initialTraderId = savedTraderObj.traderId.toString();
        }
      }

      // Fallback to first trader or user's traderId if no saved trader found
      if (!initialTraderId && user) {
        initialTraderId = user?.traders?.length > 0 
          ? user.traders[0].traderId.toString() 
          : user?.traderId?.toString() || null;
      }

      if (initialTraderId) {
        setTraderId(initialTraderId);
      }
      setLoading(false);
    }
  }, [user]);

  if (loading) {
    return <div>Loading...</div>;
  } 

  return (
    <TraderContext.Provider value={{ traderId, setTraderId }}>
      {children}
    </TraderContext.Provider>
  );
};

export const useTrader = (): TraderContextType => {
  const context = useContext(TraderContext);
  if (!context) {
    throw new Error('useTrader must be used within a TraderProvider');
  }
  return context;
};